<script lang="ts">
export default {
  name: 'AppButton',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';

export type AppButtonSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

const props = withDefaults(
  defineProps<{
    primary?: boolean;
    secondary?: boolean;
    outline?: boolean;
    success?: boolean;
    warning?: boolean;
    ghost?: boolean;
    loading?: boolean;
    disabled?: boolean;
    size?: AppButtonSize;
  }>(),
  {
    primary: false,
    secondary: false,
    outline: false,
    success: false,
    warning: false,
    ghost: false,
    loading: false,
    disabled: false,
    size: 'sm',
  },
);

const sizeClass = computed(() => `btn-${props.size}`);
</script>

<template>
  <button
    class="btn rounded-sm"
    :class="[
      sizeClass,
      {
        'btn-primary': props.primary,
        'btn-secondary': props.secondary,
        'btn-outline': props.outline,
        'btn-success': props.success,
        'btn-warning': props.warning,
        'btn-ghost': props.ghost,
        'btn-disabled': props.disabled,
      },
    ]"
    :disabled="disabled">
    <span
      v-if="loading"
      class="loading loading-spinner"></span>
    <slot />
  </button>
</template>
